import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { Button } from '../../Button/Button.js';
import '../../Button/ButtonBase/index.js';
import '../../Button/ButtonBody/index.js';
import { Text } from '../../Text/Text.js';
import { useMenuItem } from '../useMenuItem/useMenuItem.js';

var MenuItem = function MenuItem(_a) {
    var onClick = _a.onClick, id = _a.id, disabled = _a.disabled, selected = _a.selected; _a.autoFocus; var _b = _a.themeKey, themeKey = _b === void 0 ? "menuItem" : _b, children = _a.children, props = __rest(_a, ["onClick", "id", "disabled", "selected", "autoFocus", "themeKey", "children"]);
    var menuItemProps = useMenuItem({
        onClick: onClick,
        id: id,
        disabled: disabled,
        selected: selected,
    }).props;
    return (jsx(Button, __assign({ themeKey: themeKey }, menuItemProps, props, { children: jsx(Text, __assign({ truncate: true }, { children: children })) })));
};

export { MenuItem };
//# sourceMappingURL=MenuItem.js.map
